module.exports = "/fonts/vendor/devextreme/dist/css/icons/dxicons.ttf?ffe4b6c8dbdfcca28b24ff0cf1828473";